import { CSSProperties, ReactNode, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    borderRadius: '2px',
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
    '&:hover': {
      boxShadow:
        '0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
      cursor: 'pointer',
      background: theme.palette.mode === 'dark' ? '#2C2C2C' : '#FFF',
    },
  },
  cardContent: {
    height: '100%',
  },
}));

export interface EntityCardViewProps {
  content: ReactNode;
  action: () => void;
  customStyles?: CSSProperties;
}

export const EntityCard = (props: Readonly<EntityCardViewProps>) => {
  const { content, action, customStyles = {} } = props;
  const classes = useStyles();
  const [elevation, setElevation] = useState(0);

  return (
    <Card
      elevation={elevation}
      className={classes.card}
      style={customStyles}
      onClick={() => action()}
      onMouseOver={() => setElevation(1)}
      onMouseOut={() => setElevation(0)}
      data-testid="card-element"
    >
      <CardContent className={classes.cardContent}>{content}</CardContent>
    </Card>
  );
};
